import React from "react";

export const Footer = () => {
    return (
        <div className={'app-footer px-2 d-flex align-items-center'}>
            <div>© 2010-2020 «CorpSoft24» - облачные сервисы и услуги</div>
        </div>
    )
};